import { z } from "zod";

export const sampleFrameNameSchema = z.union([
    z.literal("Black"),
    z.literal("Honey"),
    z.literal("Mahogany"),
    z.literal("Vintage"),
    z.literal("Beige"),
]);

export const purchaseOrderIdSchema = z.string({message: "Your location is part of our HMIS+ integration. Please enter a valid Purchase Order ID from HMIS+."}).length(7);

export const sampleFrameQuantitiesRecordSchema = z.record(sampleFrameNameSchema, z.number());

export const packageStateSchema = z.object({
    instructions: z.string().nullable(),
    packages: sampleFrameQuantitiesRecordSchema,
});

export const frameStateSchema = z.object({
    frames: sampleFrameQuantitiesRecordSchema,
});

export const cornerStateSchema = z.object({
    corners: sampleFrameQuantitiesRecordSchema,
});
